import axiosClient from './axiosClient';

// Creditos por pagar: compras a credito (ej. a un proveedor, con una letra) que la propia
// tienda debe pagar, no un credito que se le da a un cliente.
const payableCreditsApi = {
  getPayableCredits: (params) => axiosClient.get('/payable-credits', { params }),
  getPayableCredit: (id) => axiosClient.get(`/payable-credits/${id}`),
  createPayableCredit: (data) => axiosClient.post('/payable-credits', data),
  updatePayableCredit: (id, data) => axiosClient.put(`/payable-credits/${id}`, data),
  deletePayableCredit: (id) => axiosClient.delete(`/payable-credits/${id}`),

  // Adjunto (foto o PDF de la factura/letra del proveedor): va aparte de crear/actualizar,
  // en su propio POST, porque un PUT/PATCH no puede llevar un archivo.
  uploadAttachment: (id, file) => {
    const formData = new FormData();
    formData.append('attachment', file);
    return axiosClient.post(`/payable-credits/${id}/attachment`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  removeAttachment: (id) => axiosClient.delete(`/payable-credits/${id}/attachment`),

  // Checklist de pagos: alterna pagado/pendiente al crédito completo (si es al contado) o a
  // una cuota puntual (si es a plazos).
  togglePaid: (id) => axiosClient.post(`/payable-credits/${id}/toggle-paid`),
  toggleInstallment: (id, installmentId) =>
    axiosClient.post(`/payable-credits/${id}/installments/${installmentId}/toggle`),
};

export default payableCreditsApi;
